import React from 'react';
import './Card.scss';

type CardProps = React.ComponentProps<'div'> & {
  title?: string;
  close?: () => void;
};

const Card = ({ className, children, title, close, ...rest }: CardProps) => {
  const cardTitle = title ? <div className="card-title">{title}</div> : null;
  const closeButton = close ? (
    <button
      type="button"
      className="card-close"
      onClick={close}
      aria-label="Close"
    >
      x
    </button>
  ) : null;
  return (
    <div className={`card ${className}`} {...rest}>
      {cardTitle}
      {closeButton}
      <div className="card-content">{children}</div>
    </div>
  );
};

export default Card;
